import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Oct 02 2018
 * @author BPo
 */
import * as React from 'react';
import StyledLabel from '../../typography/Label';
import Input from '../Input/Input';
import withValidation from '../withValidation';
import Icon, { IconColor, IconType } from '../../media/Icon';
import Tooltip from '../../info/Tooltip';
/**
 * Creates InputRange component - you can choose between two values
 */

var InputRange =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(InputRange, _React$PureComponent);

  function InputRange() {
    var _this;

    _classCallCheck(this, InputRange);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputRange).apply(this, arguments));

    _this.getLabel = function (props) {
      return props.labelTooltipText ? React.createElement(StyledLabel, {
        htmlFor: props.name
      }, React.createElement(Tooltip, {
        overlay: props.labelTooltipText,
        children: React.createElement("div", null, props.label)
      })) : React.createElement(StyledLabel, {
        htmlFor: props.name
      }, props.label);
    };
    /**
     * Fired when left input changed
     */


    _this.onMinChanged = function (e) {
      var value = parseFloat(e.currentTarget.value);

      if (isNaN(value)) {
        _this.props.onChange([undefined, _this.props.value[1]]);
      } else {
        _this.props.onChange([value, _this.props.value[1]]);
      }
    };
    /**
     * Fired when right input changed
     */


    _this.onMaxChanged = function (e) {
      var value = parseFloat(e.currentTarget.value);

      if (isNaN(value)) {
        _this.props.onChange([_this.props.value[0], undefined]);
      } else {
        _this.props.onChange([_this.props.value[0], value]);
      }
    };

    return _this;
  }

  _createClass(InputRange, [{
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, this.props.label && this.getLabel(this.props), React.createElement("div", {
        className: "flex justify-between items-center"
      }, this.props.clearInput && React.createElement(React.Fragment, null, React.createElement(Icon, {
        iconType: IconType.cancel,
        iconColor: IconColor.Text,
        iconHeight: 10,
        onClick: this.props.clearInput
      }), React.createElement("span", null, "\xA0")), React.createElement(Input, {
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        tiny: this.props.tiny,
        disabled: this.props.fieldReadOnly,
        onChange: this.onMinChanged,
        placeholder: this.props.placeholder[0],
        value: this.props.value[0],
        type: "number"
      }), React.createElement("span", null, "\xA0\u2014\xA0"), React.createElement(Input, {
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        tiny: this.props.tiny,
        disabled: this.props.fieldReadOnly,
        onChange: this.onMaxChanged,
        placeholder: this.props.placeholder[1],
        value: this.props.value[1],
        type: "number"
      })));
    }
  }]);

  return InputRange;
}(React.PureComponent);

InputRange.defaultProps = {
  fieldReadOnly: false,
  placeholder: [],
  tiny: false,
  value: []
};
export default InputRange;
export var InputRangeValidated = withValidation(InputRange);